module.exports = __webpack_public_path__ + "img/Vanessa.af85b73f.jpg";